export default "__VITE_ASSET__BU6VEhx2__"